var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{style:({ width: _vm.width + 'px' }),attrs:{"id":"resize"}},[_c('el-menu',{attrs:{"unique-opened":_vm.open,"collapse":_vm.isCollapse,"router":"","default-active":_vm.$route.path,"background-color":"#f7f7f7"}},[(_vm.routes.length > 0)?_c('sidebar-item',{attrs:{"routes":_vm.routes}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }